import React from 'react';
import { Box, xcss, Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

interface Props {
	restricted: boolean;
}

const RequestTypeError = ({ restricted }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={containerStyles}>
			<SectionMessage appearance="error" title={formatMessage(messages.title)}>
				<Text>
					{formatMessage(restricted ? messages.descriptionRestricted : messages.description)}
				</Text>
			</SectionMessage>
		</Box>
	);
};

export default RequestTypeError;

const containerStyles = xcss({
	marginTop: 'space.300',
});
